// plugins/universal-player.client.ts
export default defineNuxtPlugin(() => {
  // This plugin runs only on client-side
  if (process.client) {
    // You can register global video player utilities here
    console.log('Universal Video Player initialized on client')
    
    // Add global error handler for video issues
    window.addEventListener('unhandledrejection', (event) => {
      if (event.reason?.message?.includes('video') || event.reason?.message?.includes('hls')) {
        console.warn('Video player error caught:', event.reason)
        // You could send this to an error tracking service
      }
    })
  }
})
